import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { axios } from '../axios'

const Login = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (localStorage.getItem('adminToken')) {
      navigate('/private-tours', { replace: true })
    }
  }, [navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await axios.post('/api/admin/login', { email, password })
      if (res.data.success) {
        localStorage.setItem('adminToken', res.data.token)
        navigate('/private-tours', { replace: true })
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Incorrect login or password')
      localStorage.removeItem('adminToken')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#f5f7fb',
      padding: '20px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '380px',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
        padding: '28px 24px'
      }}>
        <h2 style={{ margin: 0, marginBottom: '8px', textAlign: 'center' }}>Ayrarat Admin</h2>
        <p style={{ marginTop: 0, color: '#666', textAlign: 'center', marginBottom: '20px' }}>Please sign in</p>
        {error && (
          <div style={{
            background: '#ffe6e6',
            color: '#b30000',
            padding: '10px 12px',
            borderRadius: '8px',
            marginBottom: '12px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '14px', marginBottom: '6px' }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
              style={{
                width: '100%',
                border: '1px solid #dcdfe6',
                borderRadius: '8px',
                padding: '10px 12px',
                outline: 'none'
              }}
              autoFocus
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '14px', marginBottom: '6px' }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              style={{
                width: '100%',
                border: '1px solid #dcdfe6',
                borderRadius: '8px',
                padding: '10px 12px',
                outline: 'none'
              }}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? '#6b9fc4' : '#0a5f9d',
              color: '#fff',
              border: 0,
              borderRadius: '8px',
              padding: '10px 12px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontWeight: 600
            }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
          <div style={{ fontSize: '12px', color: '#666', marginTop: '12px' }}>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login
